<section class="wraper-sub">
  <div class="sales-agent-stats-m">
    <div class="top-page-m">
      <div class="top-section">
        <h1 class="page-name">Order Classification Stats</h1>
        <!-- <div class="price-top-m">
          <p class="price-sub" data-toggle="modal" data-target="#year_selection" *ngIf="salesData">
            <span>$ {{ salesData.total_sales_amount | number }}  </span>
            <i class="fa fa-caret-down" aria-hidden="true" *ngIf="salesData && salesData.total_sales_amount != '0'"></i>
          </p>

          <div class="year-selection-m sales-selection-m" *ngIf="salesData && salesData.total_sales_amount != '0'">
            <div class="modal fade" id="year_selection" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog" style="max-width: 420px;" role="document">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel" *ngIf="salesData">Total: $ {{ salesData.total_sales_amount }}</h5>
                </div>
                <div class="modal-content">
                  <div class="modal-body">
                    <ul class="year-selection-p sales-Stats-m" *ngIf="salesData">
                      <li class="sales-top-head">
                        <span class="top-span">Sale Type</span>
                        <span class="top-span">No.of Sales</span>
                        <span class="top-span">Amount</span>
                      </li>
                      <li>
                        <label>Valid</label>
                        <span>{{ salesData.valid_sales }}</span>
                        <span>$ {{ salesData.valid_sales_amount }}</span>
                      </li>
                      <li>
                        <label>Invalid</label>
                        <span>{{ salesData.in_valid_sales}}</span>
                        <span>$ {{ salesData.in_valid_sales_amount }}</span>

                      </li>
                      <li>
                        <label>Verified</label>
                        <span>{{ salesData.verified_sales}}</span>
                        <span>$ {{ salesData.verified_sales_amount }}</span>
                      </li>
                      <li>
                        <label>Unverified</label>
                        <span>{{ salesData.un_verified_sales}}</span>
                        <span>$ {{ salesData.un_verified_sales_amount }}</span>
                      </li>
                      <li class="overall-rating">
                        <label>Overall Rating: {{ salesData.total_rating }}</label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="filter-sub-m">
        <div class="filter-m">
          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="classes"
                bindLabel="name"
                placeholder="Select Class"
                [(ngModel)]="searchParams.class"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="false"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
  					        {{ item.name }}
  					    </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="filter">
            <div class="fields-m date-filter">
              <input (onHidden)="splitFromTo()" [(ngModel)]="fullRangeDate" type="text" placeholder="Date Range" bsDaterangepicker [bsConfig]="{ isAnimated: true, showWeekNumbers: false}" >
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.2422 1.17188H12.5391V0H11.3672V1.17188H3.63281V0H2.46094V1.17188H1.75781C0.788555 1.17188 0 1.96043 0 2.92969V13.2422C0 14.2114 0.788555 15 1.75781 15H13.2422C14.2114 15 15 14.2114 15 13.2422V2.92969C15 1.96043 14.2114 1.17188 13.2422 1.17188ZM13.8281 13.2422C13.8281 13.5653 13.5653 13.8281 13.2422 13.8281H1.75781C1.43473 13.8281 1.17188 13.5653 1.17188 13.2422V5.50781H13.8281V13.2422ZM13.8281 4.33594H1.17188V2.92969C1.17188 2.6066 1.43473 2.34375 1.75781 2.34375H2.46094V3.51562H3.63281V2.34375H11.3672V3.51562H12.5391V2.34375H13.2422C13.5653 2.34375 13.8281 2.6066 13.8281 2.92969V4.33594Z" fill="#1C212D"/>
                <path d="M3.39844 6.73828H2.22656V7.91016H3.39844V6.73828Z" fill="#1C212D"/>
                <path d="M5.74219 6.73828H4.57031V7.91016H5.74219V6.73828Z" fill="#1C212D"/>
                <path d="M8.08643 6.73828H6.91455V7.91016H8.08643V6.73828Z" fill="#1C212D"/>
                <path d="M10.4297 6.73828H9.25781V7.91016H10.4297V6.73828Z" fill="#1C212D"/>
                <path d="M12.7734 6.73828H11.6016V7.91016H12.7734V6.73828Z" fill="#1C212D"/>
                <path d="M3.39844 9.08203H2.22656V10.2539H3.39844V9.08203Z" fill="#1C212D"/>
                <path d="M5.74219 9.08203H4.57031V10.2539H5.74219V9.08203Z" fill="#1C212D"/>
                <path d="M8.08643 9.08203H6.91455V10.2539H8.08643V9.08203Z" fill="#1C212D"/>
                <path d="M10.4297 9.08203H9.25781V10.2539H10.4297V9.08203Z" fill="#1C212D"/>
                <path d="M3.39844 11.4258H2.22656V12.5977H3.39844V11.4258Z" fill="#1C212D"/>
                <path d="M5.74219 11.4258H4.57031V12.5977H5.74219V11.4258Z" fill="#1C212D"/>
                <path d="M8.08643 11.4258H6.91455V12.5977H8.08643V11.4258Z" fill="#1C212D"/>
                <path d="M10.4297 11.4258H9.25781V12.5977H10.4297V11.4258Z" fill="#1C212D"/>
                <path d="M12.7734 9.08203H11.6016V10.2539H12.7734V9.08203Z" fill="#1C212D"/>
              </svg>

            </div>
          </div>

          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z" fill="#1C212D"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-tables-m">
      <div class="table-responsive">
        <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
            <tr>
              <th>S#</th>
              <th>{{ searchParams.class.name }}</th>
              <th>Order</th>
            </tr>
          </thead>
          <ng-container *ngIf="leads.data && leads.data.length > 0">
            <tbody>
              <tr *ngFor="let lead of leads.data; let indx = index">
                <td>{{ paginatePage + (indx + 1) }}</td>

                <td>
                  <p *ngIf="lead[searchParams.class.value] != 'Other' && lead[searchParams.class.value] != 'other'" [title]="lead[searchParams.class.value] | capitalize">{{ lead[searchParams.class.value] | capitalize }}</p>

                  <a *ngIf="lead[searchParams.class.value] == 'Other' || lead[searchParams.class.value] == 'other'" [title]="lead[searchParams.class.value] | capitalize" href="javascript:;" data-toggle="modal" data-target="#otherStats">{{ lead[searchParams.class.value] | capitalize }}</a>
                </td>

                <td>
                  <p>{{ lead.count }}</p>
                </td>
              </tr>
            </tbody>
          </ng-container>
        </table>
      </div>
    </div>
  </div>
</section>


<!-- view more orders modal -->
<div class="mainModal">
  <div class="modal fade" id="otherStats" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" style="max-width: 60%;" role="document">
      <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button> -->
      <div class="modal-content">
        <div class="modal-body d-block p-4">
          <!-- <h3>Other Orders</h3> -->

          <div class="data-tables-m">
            <div class="table-responsive">
              <table class="row-border hover dataTable no-footer">
                <thead>
                  <tr>
                    <th>S#</th>
                    <th>{{ "Other " + searchParams.class.name }}</th>
                    <th>Order</th>
                  </tr>
                </thead>
                <ng-container *ngIf="otherStats.length > 0">
                  <tbody>
                    <tr *ngFor="let stat of otherStats; let indx = index">
                      <td>{{ paginatePage + (indx + 1) }}</td>

                      <td>
                        <p [title]="stat['other_' + searchParams.class.value] | capitalize">{{ stat['other_' + searchParams.class.value] | capitalize }}</p>
                      </td>

                      <td>
                        <p>{{ stat.count }}</p>
                      </td>
                    </tr>
                  </tbody>
                </ng-container>
              </table>
            </div>
          </div>

          <div class="formBtns w-100">
              <button class="resetBtn" data-dismiss="modal" aria-label="Close">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- view more orders modal -->
